module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.product.message) ? _c('note', {
    attrs: {
      "type": _vm.product.status === 'error' ? 'danger' : 'warning'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.productStatusMessage)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product.stock.message) ? _c('note', {
    attrs: {
      "type": _vm.product.stock.status === 'error' ? 'danger' : 'warning'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.productStockStatusMessage)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product.price.message) ? _c('note', {
    attrs: {
      "type": _vm.product.price.status === 'error' ? 'danger' : 'warning'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.productPriceStatusMessage)
    }
  }) : _vm._e(), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Informações gerais do produto"
    }
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.product.status,
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.$t(((_vm.product.status) + ".label"))))]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md l-col-4@sm"
  }, [_c('span', {
    staticClass: "ds-block margin"
  }, [_c('strong', [_vm._v("Título:")]), _vm._v("\n         " + _vm._s(_vm.product.title) + "\n       ")])])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-4@md l-col-4@sm"
  }, [_c('span', {
    staticClass: "ds-block margin"
  }, [_c('strong', [_vm._v("Marca:")]), _vm._v("\n         " + _vm._s(_vm.product.brand) + "\n       ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md l-col-4@sm"
  }, [_c('span', {
    staticClass: "ds-block margin"
  }, [_c('strong', [_vm._v("EAN:")]), _vm._v("\n         " + _vm._s(_vm.product.ean) + "\n       ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md l-col-4@sm"
  }, [_c('span', {
    staticClass: "ds-block margin"
  }, [_c('strong', [_vm._v("SKU:")]), _vm._v("\n         " + _vm._s(_vm.product.sku) + "\n       ")])])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_vm._t("attributes")], 2)]), _vm._v(" "), (_vm.logFilters.module_identifier === 'cnova') ? _c('panel', {
    attrs: {
      "title": "Descrição"
    }
  }, [_c('form-group', {
    attrs: {
      "columns": 12,
      "label": "Descrição do Produto",
      "error": _vm.getError('description', _vm.product.productId),
      "required": true
    }
  }, [_c('quill-editor', {
    attrs: {
      "options": {
        placeholder: 'Adicione a descrição do seu produto aqui'
      }
    },
    model: {
      value: (_vm.product.description),
      callback: function($$v) {
        _vm.$set(_vm.product, "description", $$v)
      },
      expression: "product.description"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.product.crossDocking) ? _c('panel', {
    attrs: {
      "title": "Prazo extra"
    }
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.product.crossDocking.status,
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.product.crossDocking.status).label))]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Quantidade",
      "columns": 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.crossDocking.quantity),
      expression: "product.crossDocking.quantity"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.product.crossDocking.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product.crossDocking, "quantity", $event.target.value)
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Preço"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "btn btn--sm btn--info btn-history",
    on: {
      "click": _vm.showPriceHistory
    }
  }, [_c('i', {
    staticClass: "icon-folder-search"
  }), _vm._v(" "), _c('span', [_vm._v("Histórico")])]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    class: _vm.product.price.status
  }, [_vm._v(_vm._s(_vm.$t(_vm.product.price.status).label))])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('product-price', {
    attrs: {
      "input": _vm.product.price,
      "module": _vm.product.source,
      "sku": _vm.product.sku
    }
  })], 1)])]), _vm._v(" "), (_vm.logFilters.module_identifier === 'cnova') ? _c('panel', {
    attrs: {
      "title": "Dimensões"
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Altura",
      "columns": 3,
      "error": _vm.getError('product.height', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('#.##'),
      expression: "'#.##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.product.height),
      expression: "product.height"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "height", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Largura",
      "columns": 3,
      "error": _vm.getError('product.width', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('#.##'),
      expression: "'#.##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.product.width),
      expression: "product.width"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "width", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Profundidade",
      "columns": 3,
      "error": _vm.getError('product.length', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('#.##'),
      expression: "'#.##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.product.length),
      expression: "product.length"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "length", $event.target.value)
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), _vm._t("before-price"), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-flex"
  }, [_c('div', {
    staticClass: "l-col-8@md"
  }, [_c('panel', {
    attrs: {
      "title": "Estoque"
    }
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.product.stock.status,
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.product.stock.status).label))]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Quantidade",
      "columns": 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.stock.quantity),
      expression: "product.stock.quantity"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.product.stock.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product.stock, "quantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Redutor",
      "columns": 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.stock.reducer),
      expression: "product.stock.reducer"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.stock.reducer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product.stock, "reducer", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), (_vm.images.length) ? _c('panel', {
    attrs: {
      "title": "Imagens enviadas"
    }
  }, [_c('div', [_c('gallery', {
    attrs: {
      "images": _vm.images,
      "index": _vm.galleryIndex,
      "options": {
        closeOnSlideClick: true
      }
    },
    on: {
      "close": function($event) {
        _vm.index = null
      }
    }
  }), _vm._v(" "), _vm._l((_vm.images), function(image, index) {
    return _c('div', {
      key: index,
      staticClass: "image-container",
      on: {
        "click": function($event) {
          _vm.galleryIndex = index
        }
      }
    }, [_c('img', {
      attrs: {
        "src": image
      }
    })])
  })], 2)]) : _vm._e(), _vm._v(" "), _vm._t("body-bottom-left")], 2), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('simple-list-log', {
    attrs: {
      "options": _vm.logFilters
    }
  })], 1)]), _vm._v(" "), (_vm.product.attributes.length || _vm.logFilters.module_identifier === 'webcontinental') ? _c('panel', {
    attrs: {
      "title": "Atributos do produto"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.product.attributes), function(attribute) {
    return _c('div', {
      key: attribute.code,
      staticClass: "l-col-4@md l-col-4@sm"
    }, [_c('span', {
      staticClass: "ds-block margin"
    }, [_c('strong', [_vm._v(_vm._s(attribute.label) + ":")]), _vm._v("\n          " + _vm._s(attribute.valueLabel) + "\n        ")])])
  }), 0), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Garantia",
      "columns": 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.warranty),
      expression: "product.warranty"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "disabled": false
    },
    domProps: {
      "value": (_vm.product.warranty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "warranty", $event.target.value)
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.logFilters.module_identifier === 'zoom') ? _c('panel', {
    attrs: {
      "title": "Atributos do produto"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md l-col-12@sm"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t("voltage.label"),
      "columns": 3,
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.attributes['voltage']),
      expression: "product.attributes['voltage']"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.product.attributes, 'voltage', $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("Não se aplica")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "110V"
    }
  }, [_vm._v("110V")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "127V"
    }
  }, [_vm._v("127V")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "220V"
    }
  }, [_vm._v("220V")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "380V"
    }
  }, [_vm._v("380V")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bivolt"
    }
  }, [_vm._v("bivolt")])])])], 1)])]) : _vm._e(), _vm._v(" "), _c('modal-price-history', {
    attrs: {
      "sku": _vm.product.sku,
      "module": {
        'type': 'marketplace',
        'identifier': _vm.logFilters.module_identifier
      }
    },
    model: {
      value: (_vm.modalPriceHistory),
      callback: function($$v) {
        _vm.modalPriceHistory = $$v
      },
      expression: "modalPriceHistory"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f60d235","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shared/ProductEdit.vue
// module id = 3334
// module chunks = 0